import { render } from "./GamePlaning.vue?vue&type=template&id=386077cc&scoped=true"
import script from "./GamePlaning.vue?vue&type=script&lang=js"
export * from "./GamePlaning.vue?vue&type=script&lang=js"

import "./GamePlaning.vue?vue&type=style&index=0&id=386077cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386077cc"]])

export default __exports__